var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftHandAbove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 1182,
    viewBox: "0 0 421 1182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.0112 1182H300.448L419.586 565.389C421.778 552.964 421.484 540.101 418.265 529.285C415.485 515.983 409.782 504.729 401.153 495.521L225.957 282.717C215.281 270.586 198.319 265.034 182.09 269.86C157.965 275.856 143.639 298.954 147.152 322.633L122.877 300.418L176.212 56.1553C177.089 51.1853 178.403 43.7303 176.794 38.3221C174.158 9.67251 151.054 -4.64927 126.929 1.3472C110.7 6.17318 98.5656 16.8455 93.0118 33.8024L10.9982 308.912C9.68326 316.367 0.000367707 324.904 1.02382e-08 342.396C-0.000367686 359.888 9.90311 369.534 13.998 375.381C13.998 375.381 165.97 546.3 182.467 597.776C198.964 649.251 93.0112 1182 93.0112 1182Z",
    fill: "#FFCF54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.017 335.492C206.118 338.154 220.518 328.073 223.181 312.977C225.844 297.88 215.761 283.483 200.659 280.822C185.558 278.16 171.158 288.24 168.495 303.337C165.832 318.433 175.916 332.83 191.017 335.492Z",
    fill: "#FFF2D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M379.401 814.141L141.06 772.128C131.621 770.464 127.161 754.363 130.654 734.559L131.527 729.608C135.02 709.803 144.72 696.198 154.159 697.862L392.499 739.875C401.939 741.539 406.398 757.641 402.905 777.445L402.032 782.396C398.539 802.2 388.84 815.805 379.401 814.141Z",
    fill: "#C26715"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftHandAbove);
export default __webpack_public_path__ + "static/media/left-hand-above.341325a042dda63462d0a6f4d9f61677.svg";
export { ForwardRef as ReactComponent };